<template>
    <ValidationObserver ref="validationObserver" slim>
        <div class="forms-feature__form-wrapper">
            <div class="forms-feature__field-block" v-if="!IsClientKnown">
                <div class="forms-feature__field-block-title">{{Strings['Global.Address.ContactAddress']}}</div>
                <Address />
            </div>
            <div class="forms-feature__field-block">
                <div class="forms-feature__field-block-title">{{Strings['Forms.TankAbandonment.ProductFieldsTitle']}}</div>
                <div class="forms-feature__field-row">
                    <InputWithLabel :label="Strings['Forms.TankAbandonment.NumberOfTanks']"
                                    type="number"
                                    v-model="numTanks"
                                    cssclass="migrol-form__input-wrapper--medium"
                                    rules="required|integer|min_value:0|max_value:50" />
                </div>
                <div class="forms-feature__field-row">
                    <InputWithLabel :label="Strings['Forms.TankAbandonment.TankSize']"
                                    type="number"
                                    v-model="tankSize"
                                    :postfix="Strings['Shop.UnitsLiter']"
                                    cssclass="migrol-form__input-wrapper--medium"
                                    rules="required|integer|min_value:|max_value:50000" />
                </div>
                <div class="forms-feature__field-row">
                    <InputWithLabel :label="Strings['Forms.TankAbandonment.RemainingOil']"
                                    type="number"
                                    v-model="remainingOil"
                                    :postfix="Strings['Shop.UnitsLiter']"
                                    cssclass="migrol-form__input-wrapper--medium"
                                    rules="required|integer|min_value:0|max_value:50000" />
                </div>
                <div class="forms-feature__field-row">
                    <RadiobuttonList :label="Strings['Forms.TankAbandonment.TankContent']"
                                     :options="Enums['TankContents']"
                                     v-model="tankContent"
                                     rules="required" />
                </div>
                <div class="forms-feature__field-row">
                    <SelectWithLabel v-model="tankLocation"
                                     :label="Strings['Forms.TankAbandonment.TankLocation']"
                                     rules="required"
                                     :options="tankLocationsOptions" />
                </div>
                <div class="forms-feature__field-row">
                    <SelectWithLabel v-model="tankMaterial"
                                     :label="Strings['Forms.TankAbandonment.TankMaterial']"
                                     rules="required"
                                     :options="tankMaterialsOptions" />
                </div>
                <div class="forms-feature__field-row">
                    <RadiobuttonList :label="Strings['Forms.TankAbandonment.OilFromMigrol']"
                                     :options="oilFromMigrolOptions"
                                     v-model="oilFromMigrol"
                                     rules="required" />
                </div>
                <div class="forms-feature__field-row">
                    <ValidationProvider name="oilFromMIgrolExtra" rules="required" v-slot="{ errors }" slim>
                        <div class="migrol-form__input-wrapper" :class="{ 'migrol-form__input-wrapper--error' : errors.length > 0 }">
                            <div class="migrol-form__input-container--block migrol-form__radiobutton-list">
                                <Radiobutton v-for="option in oilFromMigrolInfoFilteredOptions"
                                             :key="option.value"
                                             :radioValue="option.value"
                                             v-model="oilFromMigrolInfo"
                                             :label="option.text"
                                             display="block" />
                            </div>
                            <div class="migrol-form__error-message">{{errors[0]}}</div>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="forms-feature__field-row" v-if="tankLocation !== 'Underground'">
                    <RadiobuttonList :label="Strings['Forms.TankAbandonment.IncludeRemoval']"
                                     :options="includeRemovalOptions"
                                     v-model="includeRemoval"
                                     rules="required" />
                </div>
                <div class="forms-feature__field-row">
                    <Comments />
                </div>
            </div>
            <div class="forms-feature__field-block forms-feature__field-block--no-separator">
                <div class="forms-feature__field-row">
                    <DSE v-model="dseAccepted" />
                </div>
            </div>

            <ServerErrorMessageList />

            <div class="migrol-form__buttons">
                <AjaxButton :isWaitingForAjax="isWaitingForAjax" :label="Strings['Forms.Submit']" @buttonClick="submitForm" cssclass="migrol-form__button--green" />
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'
    import $ from 'jQuery';
    import Address from '../_common/Address';
    import Comments from '../_common/Comments';
    import ServerErrorMessageList from '../_common/ServerErrorMessageList'
    import { doValidation, getEnumOptions } from '@/utils/utils'
    import { ValidationProvider } from 'VeeValidate';
    import { ValidationObserver } from 'VeeValidate'

    export default {
        data() {
            return {
                oilFromMigrolOptions: [
                    { text: this.$store.state.Strings['Forms.OptionYes'], value: 'true' },
                    { text: this.$store.state.Strings['Forms.OptionNo'], value: 'false' }
                ],
                includeRemovalOptions: [
                    { text: this.$store.state.Strings['Forms.OptionYes'], value: 'true' },
                    { text: this.$store.state.Strings['Forms.OptionNo'], value: 'false' }
                ]
            }
        },
        computed: {
            ...mapState([
                'Strings',
                'Enums',
                'IsClientKnown'
            ]),
            ...mapGetters([
                'isWaitingForAjax'
            ]),
            dseAccepted: {
                get() { return this.$store.state.dseAccepted; },
                set(val) { this.$store.commit('setDseAccepted', val); }
            },
            numTanks: {
                get() { return this.$store.state.tankAbandonment.numTanks; },
                set(val) { this.$store.commit('tankAbandonment/setNumTanks', val); }
            },
            tankSize: {
                get() { return this.$store.state.tankAbandonment.tankSize; },
                set(val) { this.$store.commit('tankAbandonment/setTankSize', val); }
            },
            remainingOil: {
                get() { return this.$store.state.tankAbandonment.remainingOil; },
                set(val) { this.$store.commit('tankAbandonment/setRemainingOil', val); }
            },
            tankContent: {
                get() { return this.$store.state.tankAbandonment.tankContent; },
                set(val) { this.$store.commit('tankAbandonment/setTankContent', val); }
            },
            tankLocation: {
                get() { return this.$store.state.tankAbandonment.tankLocation; },
                set(val) { this.$store.commit('tankAbandonment/setTankLocation', val); }
            },
            tankMaterial: {
                get() { return this.$store.state.tankAbandonment.tankMaterial; },
                set(val) { this.$store.commit('tankAbandonment/setTankMaterial', val); }
            },
            oilFromMigrol: {
                get() { return this.$store.state.tankAbandonment.oilFromMigrol; },
                set(val) { this.$store.commit('tankAbandonment/setOilFromMigrol', val); }
            },
            oilFromMigrolInfo: {
                get() { return this.$store.state.tankAbandonment.oilFromMigrolInfo; },
                set(val) { this.$store.commit('tankAbandonment/setOilFromMigrolInfo', val); }
            },
            oilFromMigrolInfoFilteredOptions: {
                get() {
                    if (this.oilFromMigrol === 'true')
                        return this.$store.state.Enums['TankOilRemovalOptions'];
                    else
                        return this.$store.state.Enums['TankOilRemovalOptions'].filter(x => x.value !== 'Return');
                }
            },
            includeRemoval: {
                get() { return this.$store.state.tankAbandonment.includeRemoval; },
                set(val) { this.$store.commit('tankAbandonment/setIncludeRemoval', val); }
            },
            tankLocationsOptions() {
                return getEnumOptions(this.Enums["TankLocations"]);
            },
            tankMaterialsOptions() {
                return getEnumOptions(this.Enums["TankMaterials"]);
            }
        },
        methods: {
            ...mapActions([
                'TriggerGoal'
            ]),
            submitForm() {
                let formData = { ...this.$store.getters['baseData'], ...this.$store.state.tankAbandonment };
                var vm = this;
                doValidation(vm.$refs.validationObserver, () => {
                    vm.$store.commit('clearServerErrormessages');
                    vm.$store.commit('increasePendingAjaxCalls');
                    $.post({
                        url: '/migrolapi/' + window.CONFIG.language + '/forms/SubmitTankAbandonmentForm',
                        data: JSON.stringify(formData),
                        contentType: 'application/json'
                    })
                        .done((response) => {
                            if (!response.Success)
                                vm.manageError(response);
                            else {
                                this.$router.push('/thanks').catch(() => { });
                                vm.TriggerGoal();
                            }
                        })
                        .fail(() => {
                            vm.manageError(null);
                        })
                        .always(function () {
                            vm.$store.commit('decreasePendingAjaxCalls');
                        });
                });
            },
            manageError(response) {
                if (!response || !response.ErrorMessages || response.ErrorMessages.length == 0)
                    this.$store.commit('addServerErrormessages', [{ TextKey: 'Shop.Errors.GenericError' }]);
                else
                    this.$store.commit('addServerErrormessages', response.ErrorMessages);
            }
        },
        components: {
            Address,
            ValidationProvider,
            ValidationObserver,
            Comments,
            ServerErrorMessageList
        }
    };
</script>